<template>
  <vs-row>
    <vs-col vs-w="12">
      <div class="vx-card show-azienda" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3 style="text-transform:uppercase">{{selected['nome']}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <vs-row>
            <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
              <sidebar-item-if-exists v-if="selected['contatto']" name="Contatto" :value="[selected['contatto']['nome'],selected['contatto']['cognome']].join(' ')"></sidebar-item-if-exists>
              <sidebar-item-if-exists v-if="selected['azienda']" name="Azienda" :value="selected['azienda']['ragione_sociale']"></sidebar-item-if-exists>
              <sidebar-item-if-exists name="Descrizione" :value="selected['descrizione']"></sidebar-item-if-exists>
            </vs-col>
            <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
              <sidebar-item-if-exists name="Data Scadenza" :value="formatDate(selected['data_scadenza'])"></sidebar-item-if-exists>
              <sidebar-item-if-exists name="Priorità" :value="selected['priorita']"></sidebar-item-if-exists>
              <sidebar-item-if-exists name="Responsabile" :value="[selected['responsabile']['nome'],selected['responsabile']['cognome']].join(' ')"></sidebar-item-if-exists>
            </vs-col>
          </vs-row>
         </div>
         <div class="vx-card__footer">
           <vs-row vs-type="flex" vs-justify="space-between">
             <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="pb-2">
               <vx-tooltip text="Crea Preventivo">
                 <vs-button v-if="selected['stato'].nome == 'Passaggio alle vendite'" @click="creaPreventivo" class="mx-1 mb-1" radius icon-pack="feather" icon="icon-file-plus" color="success" type="filled" align="right" size="large" />
               </vx-tooltip>
               <vx-tooltip text="Crea Attività">
                 <vs-button @click="creaAttivita(selected,$event)" class="mx-1 mb-1" radius icon-pack="feather" icon="icon-calendar" color="success" type="filled" align="right" size="large"></vs-button>
               </vx-tooltip>
             </vs-col>
             <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
               <star-rating :rating="selected['reputazione']" v-bind:star-size="22" :itemSize="22" :read-only="true" :max-rating="3" :show-rating="false"></star-rating>
             </vs-col>
           </vs-row>
         </div>
      </div>
      <!-- Stati lead -->
      <vx-card class="sidebar-row">
        <div>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="10">
              <h4>Avanzamento stati del lead</h4>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider />
        <vs-row class="sidebar-header-row p-5" vs-justify="flex-start">
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2">Stato attuale:</vs-col>
          <vs-col vs-w="10">
            <ul class="breadcrumbs-two ">
              <li v-for="s in stati" :key="s.id" v-bind:class="{'current': selected.stato.nome == s.nome, 'default': selected.stato.nome != s.nome, 'notcurrent': (s.nome == 'Non Soddisfatto' && selected.stato.nome == 'Non Soddisfatto')}">{{s.nome}}</li>
            </ul>
          </vs-col>
        </vs-row>
        <vs-row class="sidebar-header-row p-5" vs-justify="flex-start">
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2">Prossime azioni:</vs-col>
          <vs-col  vs-type="flex" vs-align="right" vs-w="10"><h5>{{selected.stato.descrizione}}</h5></vs-col>
        </vs-row>
      </vx-card>
      <!-- tab informazioni lead -->
      <vx-card class="sidebar-row">
        <vs-tabs alignment="fixed">
          <vs-tab label="Info Generali" icon-pack="feather" icon="icon-info" >
            <vs-row class="mt-6">
              <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Fabbisogno Cliente" :value="selected['nome']"></sidebar-item-if-exists>
              </vs-col>
              <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Data creazione" :value="formatDate(selected['data_inserimento'])"></sidebar-item-if-exists>
              </vs-col>
            </vs-row>
            <vs-row class="mt-6">
              <div class="flex items-end px-3 mt-4">
                <feather-icon svgClasses="w-6 h-6" icon="TargetIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Opportunità</span>
              </div>
              <vs-divider />
            </vs-row>
            <vs-row class="mt-6">
              <vs-col v-if="selected['servizi']" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Servizi interessati" :value="selected['servizi'].map( s => {return s.codice} ).join(', ')"></sidebar-item-if-exists>
              </vs-col>
              <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Budget" :value="selected['budget'].toLocaleString('it-IT')"></sidebar-item-if-exists>
              </vs-col>
            </vs-row>
            <vs-row class="mt-6">
              <div class="flex items-end px-3 mt-4">
                <feather-icon svgClasses="w-6 h-6" icon="CoffeeIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Coinvolgimento</span>
              </div>
              <vs-divider />
            </vs-row>
            <vs-row class="mt-6">
              <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Canale" :value="selected['canale']"></sidebar-item-if-exists>
              </vs-col>
              <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                <sidebar-item-if-exists name="Origine" :value="selected['origine']"></sidebar-item-if-exists>
              </vs-col>
            </vs-row>
          </vs-tab >
          <vs-tab label="Attività" icon-pack="feather" icon="icon-calendar" class="white_back">
            <vs-table class="mt-6" :pagination="selected['attivita_leads'].length > 5" :max-items="5" :data="selected['attivita_leads']">
                <template slot="thead">
                    <vs-th>Attività</vs-th>
                    <vs-th>Tipo</vs-th>
                    <vs-th>Descrizione</vs-th>
                    <vs-th>Responsabile</vs-th>
                    <vs-th>Stato</vs-th>
                    <vs-th>Data Completamento</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr class="row-no-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="tr.nome">
                          {{tr.nome}}
                      </vs-td>

                      <vs-td :data="data[indextr].tipo">
                        <vx-tooltip :text="data[indextr].tipo" position="left" class="tr-tooltip">
                          <vs-button v-if="data[indextr].tipo == 'Appuntamento'" disabled class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-bell"></vs-button>
                          <vs-button v-if="data[indextr].tipo == 'Telefonata'" disabled class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-phone"></vs-button>
                          <vs-button v-if="data[indextr].tipo == 'Mail'" disabled class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-mail"></vs-button>
                          <vs-button v-if="data[indextr].tipo == 'Altro'" disabled class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="tr.descrizione">
                        {{tr.descrizione}}
                      </vs-td>

                      <vs-td :data="tr.responsabile">
                        {{[tr.responsabile.cognome,tr.responsabile.nome].join(' ')}}
                      </vs-td>

                      <vs-td :data="[tr.data_scadenza,tr.data_completamento]">
                        <vx-tooltip v-if="tr.data_scadenza < new Date() && !tr.data_completamento" text="Scaduto" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-zap-off"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-else-if="tr.data_completamento" text="Completato" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-check"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-else text="Aperta" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-watch"></vs-button>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="data[indextr].data_completamento">
                          {{data[indextr].data_completamento ? formatDate(data[indextr].data_completamento) : ''}}
                      </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
          </vs-tab>
          <vs-tab label="Storia" icon-pack="feather" icon="icon-clock" class="white_back">
            <vs-table class="mt-6" :pagination="selected['stati'].length > 5" :max-items="5" :data="selected['stati']">
                <template slot="thead">
                    <vs-th>Data</vs-th>
                    <vs-th>Avanzamento stati</vs-th>
                    <vs-th>Utente</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr class="row-no-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="tr.data">
                          {{formatDate(tr.data)}}
                      </vs-td>
                      <vs-td :data="tr.stato.nome">
                          {{tr.stato.nome}}
                      </vs-td>
                      <vs-td :data="tr.utente">
                        {{[tr.utente.cognome,tr.utente.nome].join(' ')}}
                      </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
          </vs-tab >
        </vs-tabs>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import SidebarItemIfExists from '../commons/SidebarItemIfExists.vue'
import SidebarTable from '../azienda/SidebarTable.vue'
import {StarRating} from 'vue-rate-it';
import axios from 'axios'

export default {
  data() {
    return {
      componentKey: 0,
      stati: [],
    }
  },
  props: {
    selected: Object,
  },
  mounted() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/board/stato/many',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        if (this.selected.stato.nome == "Soddisfatto" || this.selected.stato.nome == "Non Soddisfatto") {
          let remove = this.selected.stato.nome == "Soddisfatto" ? 'Non Soddisfatto' : 'Soddisfatto'
          this.stati = response.data.filter(s => s.nome != remove)
        } else {
          this.stati = response.data.slice(0,4)
        }
      }).catch(e => console.log(e))
  },
  methods: {
    formatDate(date) {
      date = new Date(date)
      var options = { year: "numeric", month: "short", day: "numeric" }
      return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
    },
    closeSidebar(ev) {
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      this.$emit('close-me')
      ev.stopPropagation()
    },
    creaPreventivo(ev) {
      this.$emit('close-me')
      let type = this.selected['azienda'] ? 'az' : 'con'
      let target = type == 'az' ? this.selected['azienda']['id'] : this.selected['contatto']['id']
      let target_name = type == 'az' ? this.selected['azienda']['ragione_sociale'] : [this.selected['contatto']['cognome'],this.selected['contatto']['nome']].join('-')
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      this.$router.push({ name: 'documenti-preventivi', params: { cliente: { t: type, id: target, name: target_name, id_lead: this.selected.id } } })
      ev.stopPropagation()
    },
    creaAttivita(lead,ev) {
      let route = 'attivita-elenco'
      let l = {}
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      l['label'] = lead.nome
      l['id'] = lead.id
      this.$emit('close-me')
      ev.stopPropagation()
      this.$router.push({ name: route, params: { lead_id: l } })
    },
  },
  components: {
    SidebarItemIfExists,
    SidebarTable,
    StarRating,
  }
}
</script>
